export const MEASUREMENT_ID = 'TST01BT14C'; // Replace with our actual GA4 Measurement ID
export const GA4_MEASUREMENT_ID = '_ga_G-' + MEASUREMENT_ID;
